<template>
  <div>
    <sweet-modal :title="(operation === 'create'&& !activeIndex) ? $t('modal_addEngagement_selectEngagementTemplate') : (operation === 'create'&& activeIndex) ? $t('modal_addEngagement') : $t('modal_editEngagement')" blocking ref="addEngagement" class="modal" v-on:close="closeModal">
      <form-wizard
        shape="tab"
        ref="wizard"
        :start-index="0"
        step-size="xs"
        :color="color"
        @on-change="handleTabChange"
        @on-validate="handleValidation"
        error-color="#f56c6c"
        validate-on-back
        title=""
        subtitle=""
        @on-complete="onComplete">
        <tab-content title="Select template"
                      icon="el-icon-edit-outline">
          <el-row :span="24" :gutter="20">
            <el-col :span="8">
              <el-radio-group v-model="form.taskTreeId">
                <el-row style="padding-bottom:5px;" v-for="item in form.taskTree" :key="item.id">
                  <el-radio :label="item.id" @change="selectTemplate">{{item.name}}</el-radio>
                </el-row>
              </el-radio-group>
            </el-col>
            <el-col :span="16">
              <div>
                <img style="width:100%" :src="templateImgSrc" alt="template-img">
              </div>
            </el-col>
          </el-row>
        </tab-content>
        <tab-content title="Settings"
                      icon="el-icon-check">

          <el-form :model="form" status-icon ref="form" :rules="rules" label-position="left" label-width="0px" class="demo-ruleForm">

            <el-row :gutter="20">
              <el-col :span="14" :offset="0">
                <el-form-item size="mini" prop="name">
                  <el-input :label="$t('modal_engagementName')" v-model="form.name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10" :offset="0">
                <el-form-item size="mini" prop="regionId">
                  <el-tooltip :content="$t('modal_inDevelopment')" placement="top">
                    <el-select v-model="form.regionId" :placeholder="$t('modal_eRegion')" filterable style="width: 100%">
                      <el-option
                        v-for="regions in form.region"
                        :key="regions.id"
                        :label="regions.name"
                        :value="regions.id"
                      ></el-option>
                    </el-select>
                  </el-tooltip>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="14" :offset="0">
                <el-form-item size="mini" prop="code">
                  <el-input :label="$t('modal_code')" v-model="form.code"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10" :offset="0">
                <el-form-item size="mini" prop="engagementTypeId">
                  <el-select v-model="form.engagementTypeId" :placeholder="$t('modal_eType')" style="width: 100%">
                    <el-option
                      v-for="type in form.engagementType"
                      :key="type.id"
                      :label="type.name"
                      :value="type.id"
                      @click.native="handleSelectType(type.stages)"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="14" :offset="0">
                <!-- <el-form-item size="mini" prop="Date">
                  <el-date-picker
                    format="d MMM yy"
                    v-model="form.Date"
                    type="datetimerange"
                    prefix-icon="el-icon-date"
                    align="center"
                    range-separator=""
                    :start-placeholder="$t('modal_startDate')"
                    :end-placeholder="$t('modal_reviewDate')"
                    :picker-options="pickerOptions2"
                    value-format="ddMMyyyy"
                    style="width: 100%;">
                  </el-date-picker>
                </el-form-item> -->

                <el-row :gutter="20">
                  <el-col :span="12" :offset="0">
                    <el-form-item size="mini" prop="plannedStartDate">
                      <el-date-picker
                        v-model="form.plannedStartDate"
                        type="datetime"
                        format="d MMM yy h:mm a"
                        value-format="timestamp"
                        :placeholder="$t('modal_startDate')"
                        style="width: 100%;">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" :offset="0">
                    <el-form-item size="mini" prop="reviewDate">
                      <el-date-picker
                        v-model="form.reviewDate"
                        type="datetime"
                        format="d MMM yy h:mm a"
                        value-format="timestamp"
                        :placeholder="$t('modal_reviewDate')"
                        style="width: 100%;">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="10" :offset="0">
                <el-form-item size="mini" prop="engagementStageId">
                  <el-select v-model="form.engagementStageId" :placeholder="$t('modal_stage')" style="width: 100%">
                    <el-option
                      v-for="item in form.engagementStageList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="14" :offset="0" style="margin-bottom: -20px;">
                <el-form-item>
                  <el-col :span="24">
                    <el-radio-group v-model="form.bill">
                      <el-radio :label="0">{{$t('modal_billing_single')}}</el-radio>
                      <el-radio :label="1">{{$t('modal_billing_consolidate')}}</el-radio>
                      <el-radio :label="2">{{$t('modal_billing_notBillable')}}</el-radio>
                    </el-radio-group>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="10" :offset="0">
                <el-form-item size="mini" prop="ePriorityId">
                  <el-select v-model="form.ePriorityId" style="width: 100%">
                    <el-option
                      v-for="priority in form.ePriority"
                      :key="priority.id"
                      :label="$t(priority.translationKey)"
                      :value="priority.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="14" :offset="0">
                <el-form-item size="mini" prop="email">
                  <el-input :label="$t('modal_engagementEmail')" v-model="form.email"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10" :offset="0">
                <el-form-item size="mini" prop="eStatusId">
                  <el-select v-model="form.eStatusId" :placeholder="$t('modal_projectStatus')" style="width: 100%">
                    <el-option
                      v-for="status in form.eStatus"
                      :key="status.id"
                      :label="$t(status.translationKey)"
                      :value="status.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24" :offset="0">
                <el-form-item>
                  <el-checkbox v-model="form.isAddressAssigned">{{$t('modal_eAddress')}}</el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20" v-if="form.isAddressAssigned">
              <el-col :span="12" :offset="0">
                <el-form-item size="mini" prop="countryId">
                  <el-select v-model="form.countryId" filterable :placeholder="$t('modal_country')" style="width: 100%;">
                    <el-option
                      v-for="country in form.country"
                      :key="country.id"
                      :label="country.name"
                      :value="country.name"
                      @click.native="setState(country.id)"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12" :offset="0">
                <el-form-item size="mini">
                  <el-select no-data-text="no date" v-model="form.stateId" :placeholder="$t('modal_state')" filterable style="width: 100%;">
                    <el-option
                      v-for="item in form.state"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name"
                      @click.native="setCity(item.id)">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20" v-if="form.isAddressAssigned">
              <el-col :span="12" :offset="0">
                <el-form-item size="mini">
                  <el-select no-data-text="no date" v-model="form.cityId" :placeholder="$t('modal_city')" filterable style="width: 100%;">
                    <el-option
                      v-for="item in form.cities"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12" :offset="0">
                <el-form-item size="mini" prop="postCode">
                  <el-input :placeholder="$t('modal_postCode')" v-model="form.postCode"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20" v-if="form.isAddressAssigned">
              <el-col :span="12" :offset="0">
                <el-form-item size="mini">
                  <el-input :label="$t('modal_address_line_1')" v-model="form.address"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" :offset="0">
                <el-form-item size="mini">
                  <el-input :label="$t('modal_address_line_2')" v-model="form.address2"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20" v-if="form.isAddressAssigned">
              <el-col :span="12" :offset="0">
                <el-form-item size="mini">
                  <el-input :label="$t('modal_address_line_3')" v-model="form.address3"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" :offset="0">

              </el-col>
            </el-row>


            <div class="modal__btnDesc">
              <el-button style="width: 100%;" slot="button" v-on:click="$refs.nestedChild.open()" size="medium" type="primary" plain>{{$t('modal_aboutThisEngagement')}}</el-button>
            </div>

            <el-row :gutter="20">
              <el-col :span="14">
                <el-form-item prop="businessUnitId" size="mini">
                  <el-select disabled v-model="form.businessUnitId" :placeholder="$t('modal_engagementOwner')" style="width: 100%;">
                    <el-option
                      v-for="bu in form.businessUnitList"
                      :key="bu.id"
                      :label="bu.name"
                      :value="bu.id"
                      @click.native="handleSelectBu(bu.id, bu.leaderBU)"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item  prop="managerId" size="mini">
                  <el-select disabled v-model="form.managerId" :placeholder="$t('modal_engagementLeader')" style="width: 100%;">
                    <el-option
                      v-for="leader in form.managers"
                      :key="leader.id"
                      :label="leader.user.fullName"
                      :value="leader.id"
                      :class="{ disabled: leader.status != 1 }"
                      @click.native="handleSelectLeader(leader.id, leader.businessUnitId)"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="14">
                <el-form-item prop="engagementTeamBuId" size="mini">
                  <el-select no-data-text="no date" @remove-tag="removeBuTag" v-model="form.engagementTeamBuId" multiple :placeholder="$t('modal_businessUnits')"  style="width: 100%;">
                    <el-option
                      v-for="item in form.businessUnitList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      @click.native="handleSelectTeamBu(item.id, item.leaderBU)">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item prop="engagementTeamId" size="mini">
                  <el-select disabled no-data-text="no date" @remove-tag="removeTag" v-model="form.teamId" multiple :placeholder="$t('modal_managementTeam')"  style="width: 100%;">
                    <el-option
                      v-for="item in form.team"
                      :key="item.id"
                      :label="item.user.fullName"
                      :value="item.id"
                      :class="{ disabled: item.status != 1 }"
                      @click.native="handleSelectTeam(item.id)">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="14">
                <!-- <br> -->
                <el-button type="primary" size="mini" plain @click="addClientOpenModal" style="width: 100%;">{{$t('clients_btn_add')}}</el-button>
              </el-col>
              <el-col :span="10">
                <el-form-item size="mini">
                  <el-switch active-color="#13ce66" v-model="form.notifyTeam"></el-switch> {{$t('modal_notifyBUManagers')}}
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="14">
                <el-form-item size="mini" prop="clientsId">
                  <el-select no-data-text="no date" v-model="form.clientsId" multiple :placeholder="$t('modal_engagementClients')" style="width: 100%;">
                    <el-option
                      v-for="item in form.businessUnitClients"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                  <!-- <el-button type="primary" size="mini" plain @click="addClientOpenModal">{{$t('clients_btn_add')}}</el-button> -->
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item size="mini">
                  <el-switch active-color="#13ce66" v-model="form.notifyClients"></el-switch> {{$t('modal_notifyEClients')}}
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="14">
                <el-form-item size="mini" prop="vendorsId">
                  <el-select no-data-text="no date" v-model="form.vendorsId" multiple :placeholder="$t('modal_engagementVendors')" style="width: 100%;">
                    <el-option
                      v-for="item in form.vendors"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item size="mini">
                  <el-switch active-color="#13ce66" v-model="form.notifyVendors"></el-switch> {{$t('modal_notifyEVendors')}}
                </el-form-item>
              </el-col>
            </el-row>

          </el-form>

        </tab-content>
        <el-button size="medium" type="primary" slot="prev">{{$t('general_back')}}</el-button>
        <el-button size="medium" type="primary" slot="next">{{$t('general_next')}}</el-button>
        <el-button size="medium" type="primary" slot="finish">{{$t('general_submit')}}</el-button>
      </form-wizard>
    </sweet-modal>

    <sweet-modal ref="nestedChild">
      <vue2-custom-editor
        v-model="form.description"
        ref="editor"
        style="margin-bottom: 20px;">
      </vue2-custom-editor>
      <div class="modal__btn">
        <el-button size="medium" type="primary" slot="button" v-on:click="$refs.nestedChild.close()">{{$t('general_ok')}}</el-button>
      </div>
    </sweet-modal>

    <sweet-modal title="Adjust Permissions" width="500" blocking ref="permissions">
      <div class="permissions">
        <div>Need to adjust Team (User) permissions?</div>
        <div>Go to the Info Tab and select Permissions</div>
        <br>
        <div>For more information click on the link below</div>
        <div><a href="https://totalflow.io/permissions" target="_blank">www.totalflow.io/permissions</a></div>
      </div>
    </sweet-modal>

    <add-client-form-modal ref="modal11" :directories="directories" @selected="selectClient" :businessUnitId="form.businessUnitId"/>
  </div>
</template>

<script>
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
  import axios from 'axios'
  import AddClientFormModal from "../clients/AddClientForm";
  import Vue2CustomEditor from "../vue-2-custom-editor";
  export default {
    name: 'engagement-modal',
    components:{
      Vue2CustomEditor,
      AddClientFormModal,
      SweetModal
    },
    props:[],
    computed: {
      companyLayout() {
        return this.$store.state.companyLayout
      }
    },
    data(){
      return{
        color:'rgb(52, 152, 219)',
        templateImgSrc: 'https://dev.totalflow.io/downloads/2020/12/17/21be82a37fc1dded7b5ae34f6d18176b.png',
        operation: 'create',
        paleceholderText: 'Engagement',
        btnText:'Engagement',
        currentBusinessUnitClientsList: [],
        activeIndex: 0,
        form: {
          bill: 0,
          name: '',

          engagementStageId: '',
          engagementStageList: [],
          engagementTypeId: '',
          engagementType: [],

          description: '',
          email:'',
          engagementTeamBuId: [],
          managers: [],
          managerId:'',
          team:'',
          businessUnitId: '',
          businessUnitName: '',
          businessUnitList:[],
          teamId:[],
          clients:[],
          businessUnitClients: [],
          clientsId: [],
          vendors: '',
          vendorsId: [],
          notifyTeam: true,
          taskTree:[{
            name: this.$t('modal_addEngagement_buildNewTaskTree'),
            id: '0'
          }],
          taskTreeId: '0',
          code: '',

          eStatusId: '',
          eStatus: [],
          ePriorityId: '',
          ePriority: [],

          notifyClients: false,
          notifyVendors: false,
          regionId: '',
          region: [],
          plannedStartDate: null,
          reviewDate: null,
          Date: [],

          // Address
          isAddressAssigned: false,
          countryId: null,
          country: [],
          stateId:null,
          state: [],
          cityId: null,
          cities: [],
          postCode: null,
          address: '',
          address2: '',
          address3: '',
        },
        pickerOptions2: {
          shortcuts: [{
            text: 'Last week',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last month',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last 3 months',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        rules: {
          name: [
            { required: true, message: 'Field is required', trigger: 'blur' }
          ],
          code:[
            { required: true, message: 'Field is required', trigger: 'blur' }
          ],
          engagementStageId:[
            { required: true, message: 'Field is required', trigger: 'change' }
          ],
          businessUnitId: [
            { required: true, message: 'Field is required', trigger: 'blur' }
          ],
          engagementTeamBuId: [
            { required: true, message: 'Field is required', trigger: 'blur' }
          ],
          clientsId:[
            { required: true, message: 'Field is required', trigger: 'blur' }
          ],
          ePriorityId: [
            { required: true, message: 'Field is required', trigger: 'change' }
          ],
          eStatusId: [
            { required: true, message: 'Field is required', trigger: 'change' }
          ],
          regionId: [
            { required: true, message: 'Field is required', trigger: 'change' }
          ],
          Date: [
            { required: true, message: 'Field is required', trigger: 'blur' }
          ],
          engagementTypeId: [
            { required: true, message: 'Please input Engagement Type', trigger: 'change' }
          ]
          // plannedStartDate: [
          //   { required: true, message: 'Field is required', trigger: 'blur' }
          // ],
          // reviewDate: [
          //   { required: true, message: 'Field is required', trigger: 'blur' }
          // ],
        },
        directories: null
      }
    },
    methods:{
      setState(id, edit) {
        let loader = this.$loading.show();
        if (!edit){
          this.form.stateId = null
          this.form.cityId = null
          this.form.cities = []
        }
        if (id !== null){
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/projects/directories?companyId=${this.$route.query.companyId}&operation=getStateList&countryId=${id}`)
            .then(response => {
              loader.hide()
              console.log("ssssss", response)
              this.form.state = response.data.stateList
            })
            .catch(error => {
              loader.hide()
              this.notification("Notification", error.response.data.message, "warning")
              if (error.response.data.statusCode == 401) {
                localStorage.clear()
                this.$router.push('/login')
              }
              console.log('An error occurred:', error);
            });
        }
        loader.hide()
      },
      setCity(id, edit) {
        let loader = this.$loading.show();
        if (!edit) {
          this.form.cityId = null
        }
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/projects/directories?companyId=${this.$route.query.companyId}&operation=getCityList&stateId=${id}`)
          .then(response => {
            loader.hide()
            console.log('---/companyClients/directories', response.data);
            this.form.cities = response.data.cityList
          })
          .catch(error => {
            loader.hide()
            this.notification("Notification", error.response.data.message, "warning")
            if (error.response.data.statusCode == 401) {
              localStorage.clear();
              this.$router.push('/login')
            }
            console.log('An error occurred:', error);
          });
      },
      handleSelectType(arrStages) {
        this.form.engagementStageId = ''
        this.form.engagementStageList = arrStages
      },
      modalCancel(ref) {
        this.$refs[ref].close();
      },
      addEngagement(state){
        this.operation = state;
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/engagements/directories?companyId=${this.$route.query.companyId}&operation=${state}`)
          .then(response => {
            this.currentBusinessUnitClientsList = response.data.businessUnitList.filter(val => val.id === Number(this.$route.query.businessUnitId))[0].companyClients;

            for (let i = 0; i < response.data.engagementTemplateList.length; i++){
              this.form.taskTree.push(response.data.engagementTemplateList[i])
            }
            // this.form.businessCenters = response.data.businessCenterList;
            this.form.managers = response.data.companyUserList;
            this.form.team = response.data.companyUserList;
            this.form.businessUnitList = response.data.businessUnitList;
            // this.form.engagementStageList = response.data.engagementStageList;
            this.form.engagementType = response.data.companyTypeList;

            this.form.country = response.data.countryList

            this.form.ePriority = response.data.priorityList
            this.form.eStatus = response.data.statusList
            this.form.ePriorityId = response.data.priorityList[1].id
            this.form.eStatusId = response.data.statusList[0].id

            this.form.businessUnitId = Number(this.$route.query.businessUnitId);
            this.form.engagementTeamBuId.push(Number(this.$route.query.businessUnitId));
            this.form.teamId.push(response.data.businessUnitList.filter(val => val.id.toString() === this.$route.query.businessUnitId.toString() )[0].leaderBU.id)
            this.form.managerId = response.data.businessUnitList.filter(val => val.id.toString() === this.$route.query.businessUnitId.toString() )[0].leaderBU.id;
            this.form.businessUnitName = response.data.businessUnitList.filter(val => val.id.toString() === this.$route.query.businessUnitId.toString() )[0].name;
            // this.form.taskTree = response.data.engagementTemplateList;
            this.form.clients = response.data.companyClientList;
            // this.form.businessUnitClients = [];
            this.form.vendors = response.data.companyVendorList;
            this.form.region = response.data.regionList;
            this.$refs.addEngagement.open();
            this.filterEngClients();
            // if will be edit in bu
            if(state === 'update'){
              this.handleEdit(this.$route.query.engagementId)
            }
            loader.hide()
            this.$nextTick(() => {
              this.$refs.editor.setImagesState()
            })
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      handleEdit(id) {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/engagements/item?companyId=${this.$route.query.companyId}&engagementId=${id}`)
          .then(response => {
            if (response.data.success) {
              // let start = null
              // if (response.data.item.dateData.plannedStartDate) {
              //   start = response.data.item.dateData.plannedStartDate.toString();
              //   if (start.length < 8) {
              //     start = '0' + start
              //   }
              // }

              // let review = null
              // if (response.data.item.dateData.reviewDate){
              //   review = response.data.item.dateData.reviewDate.toString();
              //   if (review.length < 8) {
              //     review = '0' + review
              //   }
              // }

              // this.form.Date.push(start)
              // this.form.Date.push(review)
              this.form.plannedStartDate = response.data.item.plannedStartDate
              this.form.reviewDate = response.data.item.reviewDate

              this.form.name = response.data.item.name;
              this.form.code = response.data.item.code;
              this.form.description = response.data.item.description;
              this.form.phone = response.data.item.phone;
              this.form.phoneExtension = response.data.item.phone2;
              this.form.email = response.data.item.email;
              this.form.managerId = response.data.item.managerCompanyUserId;
              this.form.businessUnitId = response.data.item.businessUnit.id;
              this.form.businessUnitName = response.data.item.businessUnit.name;
              this.form.teamId = response.data.item.companyUserIdList;
              this.form.clientsId = response.data.item.companyClientIdList;
              this.form.vendorsId = response.data.item.companyVendorIdList;
              this.form.bill = response.data.item.bill;
              this.form.ePriorityId = response.data.item.priorityId;
              this.form.eStatusId = response.data.item.statusId;

              this.form.notifyClients = false
              this.form.notifyVendors = false
              this.form.regionId = response.data.item.regionId
              this.form.isAddressAssigned = response.data.item.addressData.isAddressAssigned
            }
            loader.hide()
            this.$nextTick(() => {
              this.$refs.editor.setImagesState()
            })
          })
          .catch(error => {
            loader.hide();
            console.log('An error occurred:', error);
          });
      },
      filterEngClients(){
        console.log('set clients')
        // set clients
        let clients = [];
        this.form.engagementTeamBuId.forEach(buId => {
          clients = clients.concat(this.form.businessUnitList.filter(val => val.id === buId)[0].companyClients)
        });

        const unique = [...new Set(clients.map(item => item.id))];

        let newClientList = [];
        unique.forEach(val => {
          const client = [clients.filter(bal => bal.id === val)[0]];
          newClientList = newClientList.concat(client)
        });

        this.form.businessUnitClients = newClientList;

        // check selected clients
        if (this.form.clientsId.length) {
          const clientsListIds = this.form.businessUnitClients.map(val => val.id);
          this.form.clientsId = this.form.clientsId.filter(val => clientsListIds.indexOf(val.id) > - 1)
        }
      },
      selectTemplate(templateId){
        const selectedTemplate = this.form.taskTree.filter(val => val.id === templateId);
        this.templateImgSrc = selectedTemplate[0].templateImgUrl ? selectedTemplate[0].templateImgUrl : 'https://dev.totalflow.io/downloads/2020/12/17/21be82a37fc1dded7b5ae34f6d18176b.png';
      },
      handleTabChange(prevIndex, nextIndex){
        // your logic here
        // console.log(this.VueFormWizard)
        console.log('OnChange', prevIndex, 'nextIndex', nextIndex)
        this.activeIndex = nextIndex;
      },
      handleValidation: function(isValid, tabIndex){
        // console.log('Tab: '+tabIndex+ ' valid: '+isValid)
      },
      handleSelectBu(businessUnitId, leaderBu) {
        console.log('businessUnitId', businessUnitId);
        console.log('leaderBu', leaderBu);

        // set leader to leader input
        this.form.managerId = leaderBu.id;

        const even = (element) => element === businessUnitId;
        const ifBuInTeam = this.form.engagementTeamBuId.some(even);
        if (!ifBuInTeam) {
          this.form.engagementTeamBuId.push(businessUnitId);

          // set manager to manager list
          const evenManagers = (element) => element === leaderBu.id;
          const ifUserInManagers = this.form.teamId.some(evenManagers);
          if (!ifUserInManagers) {
            this.form.teamId.push(leaderBu.id);

          }
          console.log('manager', leaderBu)


        }
        this.filterEngClients()
      },
      handleSelectLeader(leaderId, businessUnitId){
        const even = (element) => element === leaderId;
        const ifUserInTeam = this.form.teamId.some(even);
        if (!ifUserInTeam) {
          this.form.teamId.push(leaderId)
        }
        this.form.businessUnitId = businessUnitId;
        this.form.businessUnitName = this.form.businessUnitList.filter(val => val.id === businessUnitId)[0].name
      },
      removeBuTag(businessUnitId) {
        if(this.form.businessUnitId === businessUnitId) {
          this.form.engagementTeamBuId.push(businessUnitId)
          return
        }

        this.form.teamId = [];

        this.form.engagementTeamBuId.forEach(buId => {
          const leader = this.form.businessUnitList.filter(businessUnit => businessUnit.id === buId)[0].leaderBU;

          // check if user in managers
          const even = (val) => val === leader.id;
          const ifUserInTeam = this.form.teamId.some(even);

          if (!ifUserInTeam) {
            this.form.teamId.push(leader.id);
          }
        });

        this.filterEngClients()
      },
      removeTag(userId){
        if(this.form.managerId === userId) {
          this.form.managerId = null
        }
      },
      handleSelectTeamBu(businessUnitId, leaderBu) {
        console.log('businessUnitId, leaderBu', businessUnitId, leaderBu)

        const even = (element) => element === businessUnitId;
        const ifBuInTeam = this.form.engagementTeamBuId.some(even);

        // check if removed bu selected for leader
        if (!ifBuInTeam && this.form.businessUnitId === businessUnitId) {
          this.form.engagementTeamBuId.push(businessUnitId)
          return
        }

        if(!ifBuInTeam && this.form.businessUnitId !== businessUnitId) {
          // need to check if selected team still have the same leader
          this.form.teamId = [];
          this.form.engagementTeamBuId.forEach(buId => {
            const leader = this.form.businessUnitList.filter(businessUnit => businessUnit.id === buId)[0].leaderBU;
            // check if user in managers
            const even = (val) => val === leader.id;
            const ifUserInTeam = this.form.teamId.some(even);

            if (!ifUserInTeam) {
              this.form.teamId.push(leader.id);

            }
          });


        }else {
          const even = (element) => element === leaderBu.id;
          const ifLeaderInTeam = this.form.teamId.some(even);
          if(!ifLeaderInTeam) {
            this.form.teamId.push(leaderBu.id)
          }
        }

        this.filterEngClients()
      },
      handleSelectTeam(userId){
        const even = (element) => element === userId;
        const ifUserInTeam = this.form.teamId.some(even);
        if(!ifUserInTeam && this.form.managerId === userId) {
          this.form.managerId = null
        }
      },
      onComplete: function(){
        this.addEngagementSubmit('form')
      },
      addEngagementSubmit(form){
        this.$refs[form].validate((valid) => {
          if (valid) {

            if (this.form.isAddressAssigned === true) {
              if (this.form.countryId &&
                this.form.stateId &&
                this.form.cityId) {
                let loader = this.$loading.show();
                if (this.form.taskTreeId === 0){
                  this.form.taskTreeId = null
                }
                let data = {
                  name: this.form.name,
                  description: this.form.description,
                  email: this.form.email,
                  managerCompanyUserId: this.form.managerId,
                  companyUserIdList: this.form.teamId,
                  // businessUnitId: this.form.businessUnitId,
                  businessUnitIdLeader: this.form.businessUnitId,
                  businessUnitIdManagerArr: this.form.engagementTeamBuId,
                  engagementTemplateId: this.form.taskTreeId,
                  code: this.form.code,
                  companyClientIdList: this.form.clientsId,
                  companyVendorIdList: this.form.vendorsId,
                  notifyTeam: this.form.notifyTeam,
                  bill: this.form.bill,
                  priorityId: this.form.ePriorityId,
                  statusId: this.form.eStatusId,
                  engagementStageId: this.form.engagementStageId,
                  notifyClients: this.form.notifyClients,
                  notifyVendors: this.form.notifyVendors,
                  regionId: this.form.regionId,
                  isAddressAssigned: this.form.isAddressAssigned,
                  plannedStartDate: this.form.plannedStartDate,
                  reviewDate: this.form.reviewDate,
                  engagementTypeId: this.form.engagementTypeId,

                  countryName: this.form.countryId,
                  stateName: this.form.stateId,
                  cityName: this.form.cityId,
                  postCode: this.form.postCode,
                  address: this.form.address,
                  address2: this.form.address2,
                  address3: this.form.address3,
                };
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                axios.post(`/api/v1/engagements/create?companyId=${this.$route.query.companyId}`, data)
                  .then(response => {
                    console.log('---', response.data);
                    if (response.data.success){
                      loader.hide();
                      this.notification("Success", `Add ${this.btnText}`, "success");
                      this.$store.dispatch('getBusinessUnitEngagementList', this.$route.query.businessUnitId);
                      this.$store.dispatch('getCompanyLayout');
                      this.$refs.addEngagement.close()
                      this.$refs.permissions.open()
                    }
                    if (this.$refs.editor.uploadedImagesArray.length) {
                      this.$store.dispatch('approveUploadedImages', {
                        fileUrlArr: this.$refs.editor.uploadedImagesArray,
                        entityId: response.data.engagementId,
                        entityTypeId: 9 // engagement about entity
                      })
                    }
                  })
                  .catch(error => {
                    loader.hide();
                    console.log('An error occurred:', error);
                  });
              } else {
                this.$notify({
                  title: 'Notification',
                  message: 'Enter all fields Engagement Address',
                  type: 'info'
                });
              }
            } else {
              this.form.countryId = null
              this.form.stateId = null
              this.form.cityId = null
              this.form.postCode = null
              this.form.address = ''
              this.form.address2 = ''
              this.form.address3 = ''

              let loader = this.$loading.show();
              if (this.form.taskTreeId === 0){
                this.form.taskTreeId = null
              }
              let data = {
                name: this.form.name,
                description: this.form.description,
                email: this.form.email,
                managerCompanyUserId: this.form.managerId,
                companyUserIdList: this.form.teamId,
                // businessUnitId: this.form.businessUnitId,
                businessUnitIdLeader: this.form.businessUnitId,
                businessUnitIdManagerArr: this.form.engagementTeamBuId,
                engagementTemplateId: this.form.taskTreeId,
                code: this.form.code,
                companyClientIdList: this.form.clientsId,
                companyVendorIdList: this.form.vendorsId,
                notifyTeam: this.form.notifyTeam,
                bill: this.form.bill,
                priorityId: this.form.ePriorityId,
                statusId: this.form.eStatusId,
                engagementStageId: this.form.engagementStageId,
                notifyClients: this.form.notifyClients,
                notifyVendors: this.form.notifyVendors,
                regionId: this.form.regionId,
                isAddressAssigned: this.form.isAddressAssigned,
                plannedStartDate: this.form.plannedStartDate,
                reviewDate: this.form.reviewDate,
                engagementTypeId: this.form.engagementTypeId,

                countryName: this.form.countryId,
                stateName: this.form.stateId,
                cityName: this.form.cityId,
                postCode: this.form.postCode,
                address: this.form.address,
                address2: this.form.address2,
                address3: this.form.address3,
              };
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              axios.post(`/api/v1/engagements/create?companyId=${this.$route.query.companyId}`, data)
                .then(response => {
                  console.log('---', response.data);
                  if (response.data.success){
                    loader.hide();
                    this.notification("Success", `Add ${this.btnText}`, "success");
                    this.$store.dispatch('getBusinessUnitEngagementList', this.$route.query.businessUnitId);
                    this.$store.dispatch('getCompanyLayout');
                    this.$refs.addEngagement.close()
                    this.$refs.permissions.open()
                  }
                  if (this.$refs.editor.uploadedImagesArray.length) {
                    this.$store.dispatch('approveUploadedImages', {
                      fileUrlArr: this.$refs.editor.uploadedImagesArray,
                      entityId: response.data.engagementId,
                      entityTypeId: 9 // engagement about entity
                    })
                  }
                })
                .catch(error => {
                  loader.hide();
                  console.log('An error occurred:', error);
                });
            }

          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      closeModal(){
        this.form.notifyClients = false;
        this.form.notifyVendors = false;
        this.form.Date = [];
        this.form.engagementStageId = '';
        this.form.engagementStageList = [];
        this.form.engagementTypeId = ''
        this.form.plannedStartDate = null
        this.form.reviewDate = null
        this.form.regionId = '';
        this.form.region = [];

        this.form.isAddressAssigned = false;
        this.form.countryId = null;
        this.form.country = [];
        this.form.stateId = null;
        this.form.state = [];
        this.form.cityId = null;
        this.form.cities = [];
        this.form.postCode = null;
        this.form.address = '';
        this.form.address2 = '';
        this.form.address3 = '';

        this.activeIndex = 0;
        this.form.bill = 0;
        this.form.name = '';
        this.form.code = '';
        this.form.description = '';
        this.form.email = '';
        this.form.managerId = '';
        this.form.businessUnitId = '';
        this.form.businessUnitName = '';
        this.form.businessUnitList = [];
        this.form.teamId = [];
        this.form.clientsId = [];
        this.form.clients = [];
        this.form.businessUnitClients = [];
        this.form.vendorsId = [];
        this.form.notifyTeam = true;
        this.currentBusinessUnitClientsList = [];
        this.form.taskTree = [{
          name: this.$t('modal_addEngagement_buildNewTaskTree'),
          id: '0'
        }];
        this.form.taskTreeId = '0';
        this.templateImgSrc = 'https://dev.totalflow.io/downloads/2020/12/17/21be82a37fc1dded7b5ae34f6d18176b.png';
        this.$refs['form'].resetFields();
        this.$refs.wizard.navigateToTab(0)
      },
      addClientOpenModal(){
        this.$refs['modal11'].openModal()
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .get(`/api/v1/client-vendor/directories?companyId=${this.$route.query.companyId}&type=client&countryId=${this.companyLayout.currency.id}`)
          .then(response => {
            this.directories = response.data.list
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      async selectClient(id) {
        try {
          this.form.clientsId.push(id);
          const directories = await this.loadDirectories('create', id);
        } catch (err) {
          console.log(err)
        }
      },
      loadDirectories(state, clientId){
        return new Promise((resolve, reject) => {
          this.operation = state;
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/engagements/directories?companyId=${this.$route.query.companyId}&operation=${state}`)
            .then(response => {
              this.currentBusinessUnitClientsList = response.data.businessUnitList.filter(val => val.id === Number(this.$route.query.businessUnitId))[0].companyClients;
              // this.form.taskTree = response.data.engagementTemplateList;
              this.form.clients = response.data.companyClientList;
              this.form.businessUnitClients = response.data.companyClientList.filter(val => val.id === clientId);
              loader.hide()
              resolve('success')
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
              reject(error)
            });
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  /deep/.wizard-header{
    display:none;
  }
  /deep/.vue-form-wizard .wizard-nav-pills{
    display:none;
  }
  /deep/.wizard-progress-with-circle {
    display:none;
  }
  /deep/.vue-form-wizard{
    .wizard-tab-content{
      padding-top: 0 !important;
    }
  }
  .warning-message{
    margin-bottom:20px;
  }
  /deep/.el-alert__content{
    width: 100%;
    .el-alert__description {
      width: 100%;
      .alert-notification {
        display:flex;
        width: 100%;
        align-items: center;
        justify-content:space-between;
      }
    }
  }
  /deep/.el-range-separator{
    position:relative;
    &::before{
      color: #C0C4CC;
      font-family: "element-icons" !important;
      position:absolute;
      content: "\E78E";
      left: 5px;
      font-size: 14px;
      font-weight: 400;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
  }

  .sweet-modal-overlay{
    z-index:1000;
  }

  .modal {
    &__btnDesc {
      display: flex;
      justify-content: center;
      margin-bottom: 22px;
    }
    &__btn {
      text-align: right;
    }
  }
  .permissions {
    font-size: 20px;
  }
</style>
